"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrCreateClientId = getOrCreateClientId;
exports.chemkitClientIdHeader = chemkitClientIdHeader;
const presence_1 = require("./presence");
function getGlobalScope() {
    return globalThis;
}
function resolveStorage(input) {
    if (input !== undefined) {
        return input;
    }
    const scope = getGlobalScope();
    return scope.sessionStorage ?? null;
}
function createClientId() {
    const scope = getGlobalScope();
    const randomUUID = scope.crypto?.randomUUID;
    if (typeof randomUUID === "function") {
        try {
            const candidate = randomUUID.call(scope.crypto);
            if (typeof candidate === "string" && candidate.length > 0) {
                return candidate;
            }
        }
        catch {
            // fall through to deterministic fallback
        }
    }
    return `ck-${Date.now().toString(16)}-${Math.random().toString(16).slice(2)}`;
}
function getOrCreateClientId(storage) {
    const sessionStorage = resolveStorage(storage);
    if (!sessionStorage) {
        return null;
    }
    let existing = null;
    try {
        existing = sessionStorage.getItem(presence_1.CHEMKIT_PRESENCE_CLIENT_ID_STORAGE_KEY);
    }
    catch {
        return null;
    }
    if (typeof existing === "string" && existing.length > 0) {
        return existing;
    }
    const clientId = createClientId();
    try {
        sessionStorage.setItem(presence_1.CHEMKIT_PRESENCE_CLIENT_ID_STORAGE_KEY, clientId);
    }
    catch {
        return null;
    }
    return clientId;
}
function chemkitClientIdHeader(storage) {
    const clientId = getOrCreateClientId(storage);
    if (!clientId) {
        return {};
    }
    return { [presence_1.CHEMKIT_CLIENT_ID_HEADER]: clientId };
}
